<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
            </div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :display-expr="meta.extParams.displayExpr"
                    :showClearButton="meta.showClearButton || false"
                    :value-expr="meta.extParams.valueExpr"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import { getDictionary } from '@/service/card-service';

const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    if (props.meta.extParams) {
        const initialDS = [
            {
                [`${props.meta.extParams.valueExpr}`]: userData?.value[props.meta.fieldNameText],
                [`${props.meta.extParams.displayExpr}`]: userData?.value[props.meta.fieldNameId],
            },
        ];
        if (dataSource.value.length === 0 && serverData?.value.length !== 0 && initialDS) {
            dataSource.value = initialDS;
        }
    }
});

const getDictionaryHandler = async () => {
    if (props.callbacks.getDictionary) {
        await props.callbacks.getDictionary();
    } else {
        const response = await getDictionary(props.meta.extParams.dictionaryRoutePath);
        if (response) {
            dataSource.value = response;
        } else {
            console.log(response.error, response.uuid);
        }
    }
};

const valueChanged = e => {
    userDataChange(e.value, e.text);
};

const userDataChange = (value, text) => {
    userData.value[props.meta.fieldNameText] = value;
    if (text) {
        userData.value[props.meta.fieldNameId] = text;
    }
    props.callbacks.userDataChanged();
};

const value = computed(() => {
    if (userData.value[props.meta.fieldNameText] === undefined) {
        return null;
    }
    return userData.value[props.meta.fieldNameText];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
    };
});
</script>
